/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Ac_3Inputs */

const en_pc_cmp_ac_3 = /** @type {(inputs: Pc_Cmp_Ac_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You send documents out for legally binding e-signatures, or rely on multilingual OCR.`)
};

const zh_pc_cmp_ac_3 = /** @type {(inputs: Pc_Cmp_Ac_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你需要发起具有法律效力的电子签名，或依赖多语言 OCR。`)
};

/**
* | output |
* | --- |
* | "You send documents out for legally binding e-signatures, or rely on multilingual OCR." |
*
* @param {Pc_Cmp_Ac_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_ac_3 = /** @type {((inputs?: Pc_Cmp_Ac_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Ac_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_ac_3(inputs)
	return zh_pc_cmp_ac_3(inputs)
});
export { pc_cmp_ac_3 as "pc.cmp.ac.3" }